module.exports = __webpack_public_path__ + "img/candy4.23e427f0.png";